import { useState } from "react";
import { useNavigate } from "react-router-dom";
import keycloak from "../../config/keycloak";
import { SubscriptionData } from "../../interfaces/Subscription";
import UserSettingService from "../../services/userSettingService";
import "./CheckOut.css";
import { SnackbarProps } from "../common/SnackbarProps";
import { Snackbar } from "../common/Snackbar";

interface Props {
  subscription: SubscriptionData;
}

export const CheckOut: React.FC<Props> = ({ subscription }) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [acceptedAGB, setAcceptedAGB] = useState(false);
  const userSettingService = new UserSettingService();
  const [snackbar, setSnackbar] = useState<SnackbarProps>({ active: false })

  const handleConfirm = async () => {
    setLoading(true);
    try {
      await userSettingService.registerUser();
      navigate("/map");
    } catch (error) {
      triggerSnackbar("Kauf konnte nicht abgeschlossen werden ❌", "error")
    } finally {
      setLoading(false);
    }
  };

   const triggerSnackbar = (message: string, type: "success" | "error" | "info" | "warning") => {
        setSnackbar({ message: message, type: type, active: true });
        setTimeout(() => {
            setSnackbar({ active: false });
        }, 3000);
    };

  const handleCancel = () => {
    // Geht eine Seite zurück oder zu einem definierten Ziel
    navigate(-1);
  };

  return (
    <div className="checkout-container" role="dialog" aria-labelledby="checkout-title">
      <h3 id="checkout-title" className="text-xl font-semibold text-grey-800 mb-3">Bestätigung des Kaufs</h3>

      <div className="space-y-3">
        <p>
          Sie sind dabei, das <strong>{subscription.name}</strong> Abonnement für{" "}
          <strong>{subscription.price} CHF</strong> / Jahr zu erwerben.
        </p>
        <div>
          <p>
            Eine Rechnung wird an <i>{keycloak.tokenParsed?.email}</i> gesendet.
          </p>
          <p>
            <strong>Ackerplus</strong> steht Ihnen nach der Bestätigung sofort zur Verfügung.
          </p>
        </div>
      </div>

      <div className="agb-container pt-2">
        <input
          type="checkbox"
          id="agb-checkbox"
          checked={acceptedAGB}
          onChange={() => setAcceptedAGB((prev) => !prev)}
          aria-required="true"
        />
        <label htmlFor="agb-checkbox" className="agb-label">
          Ich habe die{" "}
          <a
            href="https://stframcalendarprodchno01.blob.core.windows.net/farmcalendar/public/terms-and-conditions.pdf"
            target="_blank"
            rel="noopener noreferrer"
          >
            Nutzungsbedingungen
          </a>{" "}
          gelesen und akzeptiere sie.
        </label>
      </div>

      <div className="checkout-buttons">
        <button
          className="checkout-button cancel-button font-medium"
          onClick={handleCancel}
          disabled={loading}
          aria-label="Abbrechen"
          type="button"
        >
          Abbrechen
        </button>
        <button
          className="checkout-button confirm-button font-semibold"
          onClick={handleConfirm}
          disabled={!acceptedAGB || loading}
          aria-label="Kauf abschließen"
          type="button"
        >
          {loading ? "Lädt…" : "Kaufen"}
        </button>
      </div>
      {snackbar.active && <Snackbar message={snackbar.message!} type={snackbar.type} />}
    </div>
  );
};
